module.exports = __webpack_public_path__ + "twitter-ea8188ee.png";